core.constant('templateTranslationPL', {
  "T": {
    "MODULE": {
      "TEMPLATES": {
        "TEMPLATES": "Szablony",
        "CREATE_NEW": "Utwórz nowy",
        "NEW_TEMPLATE": "Nowy szablon",
        "EDIT_TEMPLATE": "Edycja szablonu",
        "GO_BACK_TO_TEMPLATES_LIST": "Wróc do listy szablonów",
        "TEMPLATE_NAME": "Nazwa szablonu",
        "CREATION_DATE": "Data utworzenia",
        "DO_YOY_REALLY_WANT_TO_DELETE_TEMPLATE": "Czy na pewno chcesz usunąć wybrany szablon",
        "DELETE_TEMPLATE": "Usuń szablon",
        "CREATE_NEW_TEMPLATE": "Tworzenie nowego szablonu",
        "HERE_YOU_CAN_ADD_NEW_TEMPLATE_AND_SAVE_IT": "Tutaj możesz skonfigurować nowy szablon i go zapisać",
        "HERE_YOU_CAN_VIEW_TEMPLATE_AND_MODIFY_IT": "Tutaj możesz podejrzeć szablon i wprowadzić do niego zmiany",
        "EDIT_TEMPLATE": "Edycja szablonu",
        "NO_TEMPLATES_FOUND": "Nie znaleziono szablonu",
        "FIND_IN_TEMPLATES": "Szukaj w szablonach...",
        "CREATE_FROM_DATA": "Utwórz szablon z wypełnionych danych",
        "ENTER_TEMPLATE_NAME": "Wpisz nazwę szablonu...",
        "AT_LEAST_ONE_FIELD_REQUIRED": "Wymagane jest wypełnienie co najmniej jednego pola karty wizyty",
        "SEARCH": "Szukaj",
        "USE_TEMPLATE": "Użyj szablonu",
        "REPORTS": "Raporty"
      }
    }
  }
});
